import { ChannelType } from "@/app/shared/utils/enums";
import EventBus from "@/app/shared/utils/eventBus";
import { getChannelCustomerIdentifier } from "@/app/shared/utils/helpers";
import { WorkspaceEvent } from "@/app/workspace/domain/events";
import { resolveTicketById, saveManagement } from "@/app/workspace/services";
import { ticketService } from "@/app/workspace/services/TicketService";
import JssipStorage from "@/packages/vue-jssip/jssip/storage";

export function useSaveTypificationManagement() {
  const saveTypificationManagement = async ({
    typification,
    ticket,
    interactionId,
    shouldResolveTicket = false,
    isInCall = false,
    isCurrentTicket = false,
    saveManagementAndFinishCall = false,
    observations = "-",
    ticketTypification,
    routeTicket,
    strategyPhone = null,
    strategyPhoneId = null,
    deleteTypificationFromLocalStorage,
  }) => {
    const channel = typification?.channel;
    if (!channel) return false;

    const management = {
      phone_number: [ChannelType.Voice, ChannelType.Whatsapp, ChannelType.VoiceInbound, ChannelType.WhatsappVoice].includes(channel?.channel?.id)
              ? channel?.identifier
              : null,

      // phone_number: channel?.channel?.id === 1 ? channel?.identifier : null,
      identifier: channel?.identifier,
      channel_customer_identifier: getChannelCustomerIdentifier({
        channel: channel?.channel,
        channelCustomer: channel?.channel_customer,
      }),
      channel_customer: channel?.channel_customer?.id,
      asterisk_id: channel?.asterisk_id ?? undefined,
      strategy_phone: strategyPhone,
      ticket,
      interaction_id: interactionId,
      type_interaction: channel?.type_interaction,
      type_service: typification?.type_service,
      group_pallete: typification?.formState?.group_pallete,
      result_pallete: typification?.formState?.result_pallete,
      motive_pallete: typification?.formState?.motive_pallete,
      submotive_pallete: typification?.formState?.submotive_pallete,
      comment: typification?.formState?.comment,
      form: typification?.formFields,
      strategy: typification?.isStrategyOn,
      strategy_phone_id: strategyPhoneId,
      ivr: typification?.$jssip?.phone?.meta?.ivr?.ivr?.id,
      summary: typification?.conclusion,
    };

    await saveManagement(management);

    if (ticket) {
      await ticketService.updateTicket(ticket, { enabled_to_transfer: true });
    }

    if (isInCall) {
      typification?.$jssip?.updatePhoneTicketTypificated(true);
    }

    console.log('shouldResolveTicket', shouldResolveTicket, 'ticket', ticket, 'observations', observations);

    if (shouldResolveTicket) {
      await resolveTicketById(ticket, { observations: observations || "-" });
    }

    const finishCall =
      (isInCall && isCurrentTicket && saveManagementAndFinishCall) || shouldResolveTicket;

    if (finishCall || !isInCall) {
      EventBus.$emit(WorkspaceEvent.MANAGEMENT_SAVED, {
        isTypificationDefault: false,
        shouldResolveTicket,
        ticketId: ticket,
        finishCall,
      });
    }

    deleteTypificationFromLocalStorage?.();

    if (ticketTypification == routeTicket && (finishCall || !isInCall)) {
      JssipStorage.clearAcwTime();
    }

    return { saved: true, finishCall };
  };

  return { saveTypificationManagement };
}
